import useIssueStore from '@/state/issueState';
import useOrganizationStore from '@/state/orgState';
import usePrStore from '@/state/prState';
import useUserStore from '@/state/userState';
import { IssueReqOrg } from '@/types/issueReqType';
import { PrReqOrg } from '@/types/prReqType';
import Repository from '@/types/repositoryType';

const changeIssueForOrg = async (repository: Repository) => {
  const setIssueListOrg = useIssueStore.getState().setIssueListOrg;
  const user = useUserStore.getState().user;
  const organization = useOrganizationStore.getState().organization;
  const issueReq: IssueReqOrg = {
    UserUUID: user.UserUUID,
    OrganizationUUID: organization?.OrgUUID,
    Source: repository?.Source,
  };

  if (!user.UserUUID || !organization?.OrgUUID) {
    return;
  }

  setIssueListOrg(issueReq);
};

const changePrForOrg = async (repository: Repository) => {
  const user = useUserStore.getState().user;
  const organization = useOrganizationStore.getState().organization;
  const setPRListOrg = usePrStore.getState().setPrListOrg;

  if (!user.UserUUID || !organization?.OrgUUID) {
    return;
  }

  const prReq: PrReqOrg = {
    UserUUID: user.UserUUID,
    OrganizationUUID: organization?.OrgUUID,
    Source: repository?.Source,
  };
  setPRListOrg(prReq);
};

const changePrAndIssueForOrg = async (repository: Repository) => {
  changeIssueForOrg(repository);
  changePrForOrg(repository);
};

export default changePrAndIssueForOrg;
